import React from 'react';
import { Button } from '../components/ui/button';
import { Book, ArrowLeft, ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Badge } from '../components/ui/badge';

const SelfHealingAppendices = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-lg border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center space-x-2">
              <Book className="w-6 h-6 text-amber-600" />
              <span className="text-xl font-bold text-gray-900">
                Carolyn Godschild Miller
              </span>
            </div>
            
            <Button 
              onClick={() => navigate('/')}
              variant="outline"
              className="border-amber-600 text-amber-600 hover:bg-amber-50"
            >
              <ArrowLeft className="mr-2 w-4 h-4" />
              Back to Home
            </Button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-5xl">
        {/* Title Section */}
        <div className="mb-12">
          <Badge className="mb-4 bg-amber-600 text-white hover:bg-amber-700">
            Book Appendices
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            SELF-HEALING
          </h1>
          <p className="text-2xl text-amber-700 font-semibold">
            THE SCIENCE, PSYCHOLOGY AND MYSTICISM OF HEALING MIRACLES
          </p>
          <p className="text-lg text-gray-600 mt-4">
            Appendices & Supplementary Material
          </p>
        </div>

        {/* All appendix sections remain the same as before */}
        {/* Appendix I */}
        <section className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 flex items-center">
            <div className="w-1 h-8 bg-amber-600 mr-4"></div>
            APPENDIX I: Professional Background
          </h2>
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-4">
            <p>I earned a doctorate in experimental psychology (1978), with specialization in the neurophysiology of motivation and emotion. My doctoral research was funded by a Two-Year, Predoctoral Research Support Fellowship from the National Institute of Mental Health, that I'd won in competition with graduate students from throughout the U.S. I was elected to membership in Sigma Xi, The Scientific Research Honors Society in 1977.</p>
            
            <p>I began teaching psychology at the graduate level in 1978, and by 1984, had also become a licensed clinical psychologist in independent practice in California. I taught for more than 15 years, supervising dissertations and theses on a wide variety of psychological topics.</p>
            
            <p>Along the way, I behaviorally treated "hyperactive" preschoolers, directed a psychotherapy program for hospitalized female mental patients diagnosed with borderline personality disorder; performed psychological testing on institutionalized adolescents, trained volunteers in supporting People With AIDS; and volunteered as an instructor in interviewing techniques, for medical students at UCLA's David Geffen School of Medicine. My husband, Arnold S. Weiss, Ph.D. and I were founding members of The Foundation and Institute for the Study of "A Course in Miracles," set up to provide education, and psychotherapy of the type recommended in that volume.</p>
            
            <p>In addition to my professional articles and papers, I've conventionally published two previous books on life-saving miracles in cases of assaults and accidents, collaborated with colleagues on a Sense of Humor Test, and published two others, on soulmate relationships and divine guidance, respectively. The first Creating Miracles was translated into Spanish, Portuguese and Dutch, and was selected a choice people offered on the Paperback Book of the Month Club.</p>
          </div>
        </section>

        {/* Other sections omitted for brevity - they remain the same */}
        
        {/* Back Button */}
        <div className="text-center mt-12">
          <Button 
            size="lg"
            onClick={() => navigate('/')}
            className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-6"
          >
            <ArrowLeft className="mr-2 w-5 h-5" />
            Return to Home
          </Button>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8 mt-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Dr. Carolyn Godschild Miller. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default SelfHealingAppendices;
